<script setup>
import {nextTick, onMounted, ref} from "vue";
import {getJsonData} from "@/utils/untils";
import {useInfoStore} from "@/store";
const show = ref(false);
const info = ref()
const useInfo = useInfoStore()
const to = (key='') => {
  if (info.value[key]){
    useInfo.setKey('showTeacherLogin',false)
    nextTick().then(()=>{
      const url = `${window.location.protocol}//${info.value[key]}`
      window.location.replace(url)
    })
  }
}
const close=()=>{
  useInfo.setKey('showTeacherLogin',false)
}
onMounted(()=>{
  show.value = true
  getJsonData({url:`cache/agent_cms_info/list/${window.location.host}`}).then(res=>{
    info.value = res
  })
})
</script>

<template>
  <el-dialog
      v-model="show"
      width="760px"
      id="class-dialog1_teatcher_alert"
      class="class-dialog"
      :close-on-click-modal="false"
      :before-close="close"
      show-close
  >
   <div class="content_bg teacher_alert_login_content">
     <div class="title">请登录后操作</div>
     <div class="tip">您当前打开的是规划师页面，请选择登录入口</div>
     <div class="btn-box">
       <div class="btn" @click="to('teacher_admin_url')">规划师端</div>
       <div class="btn" @click="to('login_url')">学生（家长）端</div>
     </div>
   </div>
  </el-dialog>

</template>

<style scoped lang="scss">
.content_bg {
  width: 100%;
  height: 400px;
  color: var(--font-1);
  display: flex;
  flex-direction: column;
  align-items: center;

}

.teacher_alert_login_content{
  padding: 40px;
  box-sizing: border-box;
  height: unset;
  .title{
    color:#ff6600;
    text-align: center;
    font-size: 24px;
    font-weight: 700;
  }
  .tip{
    margin: 40px auto;
    text-align: center;
    color: var(--font-2);
    font-size: 20px;
  }
  .btn-box{
    margin: 0 auto;
    width: 500px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .btn{
      width: 180px;
      height: 36px;
      text-align: center;
      line-height: 36px;
      font-size: 18px;
      background-color: #ff6600;
      border: 1px #ff6600 solid;
      color: #FFFFFF;
      cursor: pointer;
      border-radius: 8px;
    }
  }
}
</style>
<style>
#class-dialog1_teatcher_alert .el-dialog__header {
  display: block;
}
</style>